import { createContext } from "react";

const CustomNotificationsContext = createContext({
  error: (notificationMessage) => {},
});

export default CustomNotificationsContext;
